import React from "react";
import Helmet from "react-helmet";
import whiteVideoSquirrelLogo from "../../assets/whiteVideoSquirrelLogo.svg";
import styles from "./OnboardingPage.module.scss";

function OnboardingPage({ title, children }) {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={styles.root}>
          <div className={styles.leftGridItem}>
            <div className={styles.logo}>
              <img src={whiteVideoSquirrelLogo} alt="" />
            </div>
          </div>
        <div className={styles.rightGridItem}>{children}</div>
      </div>
    </>
  );
}

export default OnboardingPage;
